import { AwardingClient } from "@/utils/EvoClient";
import { CreateParticipantDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/create-participant";

export default async function createParticipant(
  dto: CreateParticipantDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
